import { ConfirmUnsaved } from "components/ConfirmDialog/ConfirmUnsaved";
import { HookFormDebug } from "components/FormDebug/HookFormDebug";
import { EditFormFooter } from "components/Forms/EditFormFooter";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useEditParticipant } from "providers";
import { useTranslations } from "providers";
import React from "react";

import { EditParticipantForm } from "./EditParticipantForm";

export const EditParticipantPanel: React.FC = () => {
  const i18n = useTranslations();
  const {
    confirmParticipantUnsaved,
    setConfirmParticipantUnsaved,
    editParticipantId,
    isDirty,
    isValid,
    isSubmittable,
    isSubmitting,
    getPatch,
    handleSave,
    handleClose,
    form,
  } = useEditParticipant();

  if (editParticipantId === -1) {
    return null;
  }

  const saveButtonDisabled = !isDirty || !isValid;
  return (
    <>
      <SlidingPanel
        isOpen={true}
        onCancel={() => handleClose(true)}
        onSave={() => handleSave()}
        onClose={() => handleClose()}
        panelClassName="edit-participants-panel panel-form"
        panelContainerClassName=""
        saveButtonDisabled={saveButtonDisabled}
        isSubmitting={isSubmitting}
        debugContent={
          <HookFormDebug
            watch={() => getPatch(form.watch())}
            formState={form.formState}
            isSubmitting={isSubmitting}
            isSubmittable={isSubmittable}
          />
        }
        header={<h1>{i18n.EditParticipantPanel_Header}</h1>}
        footer={
          <EditFormFooter
            onCancel={() => handleClose(true)}
            onSubmit={() => handleSave()}
            isSubmitting={isSubmitting}
            isDirty={isDirty}
          />
        }
      >
        <EditParticipantForm />
      </SlidingPanel>

      <ConfirmUnsaved
        onAccept={() => handleClose(true)}
        isOpen={confirmParticipantUnsaved}
        setIsOpen={setConfirmParticipantUnsaved}
        onCancel={() => setConfirmParticipantUnsaved(false)}
      />
    </>
  );
};
